import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_cf_element_link_RowClass } from "../../../dbschema";

export class BotCfElementLinkContainerModel extends BaseContainerModel{
  alg_bot_cf_element_link: alg_bot_cf_element_link_RowClass = new alg_bot_cf_element_link_RowClass();
}
